// extracted by mini-css-extract-plugin
export default {"alert-danger":"rgb(218, 30, 40)","alert-danger-light":"rgb(252, 245, 246)","container":"styles_container__e2VUT","errorMessageBanner":"styles_errorMessageBanner__QV-lK"};